import { render, staticRenderFns } from "./SelectFormModal.vue?vue&type=template&id=0b295a83"
import script from "./SelectFormModal.vue?vue&type=script&lang=js"
export * from "./SelectFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports